import styled from 'styled-components';
import { exactWhite } from '../../../../utils/style/colors';

export const Wrapper = styled.div`
  display: flex;
  flex-grow: 1;
  flex-shrink: 1;
  max-height: 100%;

  & > div:first-child {
    flex-basis: 11rem;
    flex-grow: 0;
    margin-left: 1rem;
    margin-top: 1rem;
  }
`;

export const ClassListCol = styled.col`
  width: 200px;
`;

export const SelectedItemContainer = styled.div`
  flex: 1;
  overflow: auto;
`;

export const CompanySelectorContainer = styled.div`
  & > span > div {
    border: none;
    background: transparent;
    box-shadow: none;
    margin-top: 0;
    padding: 0 0.5rem;
    & > i {
      color: #9e9e9e;
      margin-bottom: 1rem;
    }
    & > label {
      font-size: 0.9rem;
      color: #9e9e9e;
    }
    & > div {
      margin-top: 0.5rem;
    }
  }
`;

export const CoursePhaseContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const PhaseRow = styled.div`
  display: flex;
  align-items: center;
  padding: 0 1rem;
  flex-wrap: wrap;
`;

export const PhaseRowContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
`;

export const CoursePhaseContainerAPopover = styled.div`
  width: 35rem;
  background: ${exactWhite};
  padding: 0.5rem 0.75rem;
  text-align: ${(props) =>
    props.theme.direction === 'rtl' ? 'right !important;' : 'left !important;'};
`;
